/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AutoForm } from '../../common/auto-form';
import { APV_HORIZONTE_FIELDS } from './fields';
import { APVHorizonteResultView } from './result-view';
import {
  APVHorizonteFormValues,
  apvHorizonteDefaults,
  apvHorizonteSchema,
} from './schema';
import { PRODUCT, buildAPVHorizontePayload, simulateAPVHorizonte } from './service';

export function APVHorizontePage() {
  const [lastRequest, setLastRequest] = useState<unknown>(null);

  const mutation = useMutation({
    mutationFn: (values: APVHorizonteFormValues) => simulateAPVHorizonte({ values }),
  });

  const hasResult = mutation.isSuccess || mutation.isError;

  return (
    <>
      <div className="card">
        <div className="card-body">
          <AutoForm
            fields={APV_HORIZONTE_FIELDS}
            schema={apvHorizonteSchema}
            defaults={apvHorizonteDefaults}
            isLoading={mutation.isLoading}
            expectedProduct={PRODUCT}
            onSubmit={(values) => {
              const payload = {
                product: PRODUCT, ...buildAPVHorizontePayload(values), debug: true,
              };
              setLastRequest(payload);
              mutation.mutate(values);
            }}
          />
        </div>
      </div>

      {hasResult && (
        <APVHorizonteResultView
          request={lastRequest}
          response={mutation.data}
          error={mutation.isError ? mutation.error : undefined}
        />
      )}
    </>
  );
}
